import { createAction } from 'redux-actions';

export const resetDonorSummaryReport = createAction(
  'RESET_INVENTORY_DONOR_SUMMARY_REPORT'
);

export const updateDonorSummaryReportSearchQuery = createAction(
  'UPDATE_INVENTORY_DONOR_SUMMARY_REPORT_SEARCH_QUERY'
);
